import { Redirect } from '#app/components/Redirect/index.js';
import { useURLParameters } from '#app/hooks/useURLParameters.js';
import { getRoute } from '@contra/routes';

export const Page = () => {
  const [searchParameters] = useURLParameters('/community');
  const search = Object.fromEntries(
    Object.entries(searchParameters).filter(([, value]) => Boolean(value)),
  );

  return (
    <Redirect
      method="replace"
      to={getRoute('/community/recent', {
        search,
      })}
    />
  );
};
